import { Injectable } from '@angular/core';
import { HttpService } from './../services/http.service';
import { DIMBO_CONSTANT } from './../utils/constants';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private httpService : HttpService) { }


  // Method to call a API for login authentication.
  public authenticatWithLdap(userName: string, password: string) {
     return this.httpService.loginHeaders(DIMBO_CONSTANT.AUTHENTICATE_LOGIN_LDAP, userName,password);
  }
}
